(function ($) {

  var acc = document.getElementsByClassName("store-switcher-accordion");
  var i;

  const body = $("body");
  const toggle = $(".store-switcher");
  const popup = $(".store-switcher-popup");
  const popupOverlay = $(".store-switcher-popup-overlay");
  const popupExitButton = $(".store-switcher-exit-button");

  const test = $(".close-button") ;
  console.log(test);

  // Strip known market prefixes so the path portion is market-agnostic
  var marketPrefixes = ['/en-bi', '/en-eu', '/en-us', '/en-neu', '/en-aunz', '/en-ea'];
  var currentPath = window.location.pathname;
  for (var p = 0; p < marketPrefixes.length; p++) {
    if (currentPath.indexOf(marketPrefixes[p]) === 0) {
      currentPath = currentPath.slice(marketPrefixes[p].length) || '/';
      break;
    }
  }

  // Append current path to each switcher link so the user lands on the same page
  popup.find('a[href]').each(function () {
    var base = $(this).attr('href').replace(/\/$/, '');
    $(this).attr('href', base + currentPath);
  });

  toggle.on("click", function (e) {
    e.preventDefault();
    popup.addClass('open');
    popupOverlay.addClass('open');
    body.addClass('stop-scroll');
  });

  function closePopup() {
    popup.removeClass('open');
    body.removeClass('stop-scroll');
    popupOverlay.removeClass('open');
    setTimeout(function () {
      for (i = 0; i < acc.length; i++) {
        acc[i].classList.remove("active");
        var panel = acc[i].nextElementSibling;
        panel.style.maxHeight = null;
      }
    }, 200);
  }

  popupOverlay.on("click", function () {
    closePopup();
  });

  popupExitButton.on("click", function () {
    closePopup();
  });




  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

})(jQuery); 